module.exports = __webpack_public_path__ + "53f2b197ee5393d29b1ce189d2390fcb.svg";